import * as ng from 'angular';

const editorFooterView = require('./editor-footer.html');

ng.module('e360')
   .directive('editorFooter', editorFooterDirective);

// this would be a great fit for a component but we need data- attribute support
// because mandrill strips non-html elements, and components must be elements
export function editorFooterDirective() {
   return {
      restrict: 'EA',
      templateUrl: editorFooterView,
      transclude: true,
      scope: {
         footer: '<',
         mirror: '<'
      }
   }
}
